(function () {
  // Delegated listener: the "Add free" button is rendered/removed by the
  // cart's own Liquid re-render on every add/remove/quantity change (see
  // snippets/cart-drawer.liquid), so it may not exist yet at page load.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-upsell-add]');
    if (!button || button.disabled) return;
    button.disabled = true;

    var cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { id: button.getAttribute('data-variant-id'), quantity: 1 };
    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      body.sections = cartElement.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        var updatedCartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (updatedCartElement && typeof updatedCartElement.renderContents === 'function' && body.sections) {
          updatedCartElement.renderContents(response);
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell', cartData: response });
      })
      .catch(function (e) {
        console.error('cart-drawer-upsell:', e);
        button.disabled = false;
      });
  });
})();
